var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category bold"},_vm._l((_vm.categorys),function(item,index){return _c('div',{key:index,staticClass:"category-item",class:{'active' : _vm.categoryId === item.id},on:{"click":function($event){return _vm.onChangeCategory(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }